import React, { useEffect, useState, useContext, useRef } from 'react';
import { useField, useFormikContext } from 'formik';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import styled from 'styled-components';
import HeaderInfoM from '../lib/typography/HeaderInfoM';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import MenuItem from '@mui/material/MenuItem';

const Wrapper = styled.div`
  display: flex;
  justifyContent: center;
  flex-direction: column;
  padding: 15px;
  border 1px solid #CCC;
  border-radius: 6px;
`;

const capitalize = (s) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const EditExtraCategories = (props) => {
  const { mainCategory, extraCategories } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [categories, setCategories] = useState(extraCategories);
  const [newCategory, setNewCategory] = useState(false);
  const [availableCategories, setAvailableCategories] = useState([]);
  const {
    categories: { categoryId__category },
  } = placeState;
  const [field, meta] = useField(props);
  const { values, setFieldValue } = useFormikContext();
  const { service_id, category } = values;

  const serviceIdRef = useRef(service_id);

  useEffect(() => {
    setAvailableCategoriesOnChange();
  }, [mainCategory]);

  useEffect(() => {
    setFieldValue('extraCategories', categories);
    setAvailableCategoriesOnChange();
  }, [categories]);

  useEffect(() => {
    if (service_id !== serviceIdRef.current) {
      setNewCategory(false);
      setCategories([]);
    }
  }, [service_id]);

  const setAvailableCategoriesOnChange = () => {
    const newAvailableCategories = [];
    for (const categoryId in categoryId__category) {
      if (categoryId__category[categoryId].group) continue;
      if (
        categoryId__category[categoryId]?.service_id === categoryId__category[mainCategory]?.service_id &&
        !categories.includes(categoryId) && categoryId !== mainCategory
      ) {
        newAvailableCategories.push(categoryId__category[categoryId]);
      }
    }
    setAvailableCategories(newAvailableCategories.sort((a, b) => a.name.localeCompare(b.name)));
  }

  const handleChangeCatgory = (e) => {
    const newCategories = [...categories, e.target.value];
    setCategories(newCategories);
    setNewCategory(false);
  };

  const handleAddContent = () => {
    setNewCategory(true);
  };

  const handleRemoveContent = (e, index) => {
    const newCategories = [...categories];
    if (index > -1) {
      newCategories.splice(index, 1);
    }
    setCategories(newCategories);
  };

  const handleRemoveAllContent = (e, index) => {
    setNewCategory(false);
  };

  if (category === '') {
    return (
      <TextField
        required
        fullWidth
        select
        variant="outlined"
        label="No main category selected"
        disabled
        value={''}
      >
        <MenuItem value={''}>
          {''}
        </MenuItem>
      </TextField>
    )
  }

  if (availableCategories.length === 0 && categories.length === 0) return null;

  return (
    <Wrapper>
      <HeaderInfoM
        name="Be part of aditional categories"
        size="1rem"
        color="#000000"
        style={{ padding: '2px', letterSpacing: '-0.05em', marginBottom: '10px' }}
      />
      {categories.map((categoryId, index) => {
        return (
          <div key={index} className="f-c f-aic mb-8">
            <p>{categoryId__category[categoryId]?.name}</p>
            <RemoveCircle
              className="ml-8 s-24-i"
              color="error"
              onClick={(e) => handleRemoveContent(e, index)}
              style={{ alignSelf: 'center', cursor: 'pointer' }}
            />
          </div>
        );
      })}
      {newCategory && (
        <div className="mb-8 ml-4">
          <TextField
            required
            fullWidth
            select
            variant="outlined"
            label="Select Aditional Category"
            value={''}
            onChange={handleChangeCatgory}
          >
            {availableCategories.map((category, index) => {
              return (
                <MenuItem key={index} value={category.id}>
                  {category.name}
                </MenuItem>
              );
            })}
          </TextField>
        </div>
      )}
      <div style={{ display: 'flex' }}>
        {!newCategory && availableCategories.length> 0 && <Fab color="primary" aria-label="add" size="small" onClick={handleAddContent}>
          <AddIcon />
        </Fab>}
        {newCategory && <Fab aria-label="add" size="small" onClick={handleRemoveAllContent} style={{ backgroundColor: 'red', color: 'white'}}>
          <RemoveCircle />
        </Fab>}
      </div>
    </Wrapper>
  );
};
